import logo from "@/assets/app-logo.svg";
import logoText from "@/assets/pulse-text-logo.svg";
import { NavLink } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Button } from "../ui/button";
import {
  LogOutIcon,
  MailIcon,
  MoreHorizontalIcon,
  RotateCwIcon,
} from "lucide-react";
import { useLogout } from "@/tanstack-hooks";
import { useTranslation } from "@/hooks/useTranslation";
import { useQueryClient } from "@tanstack/react-query";
import { reloadApp } from "@/lib/reloadApp";

const HeaderWithLogout = ({
  showRefreshButton,
  showContactButton,
}: {
  showRefreshButton: boolean;
  showContactButton: boolean;
}) => {
  const logoutMutation = useLogout();
  const t = useTranslation();
  const queryClient = useQueryClient();

  function handleSignOut() {
    logoutMutation.mutate({});
  }

  function MoreOptionsButton() {
    return (
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button variant="default" className="px-3">
            <MoreHorizontalIcon className="h-6 w-6" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="dark rounded-2xl">
          {showRefreshButton && (
            <DropdownMenuItem
              className="gap-5 py-3 rounded-xl hover:cursor-pointer"
              onClick={() => reloadApp(queryClient)}
            >
              <RotateCwIcon size={16} />
              <span>{t.SHARED.LABELS.REFRESH_BUTTON}</span>
            </DropdownMenuItem>
          )}
          {showContactButton && (
            <DropdownMenuItem
              className="gap-5 py-3 rounded-xl hover:cursor-pointer"
              asChild
            >
              <a href="mailto:support@pulse-date.com">
                <MailIcon size={16} />
                <span>{t.SHARED.LABELS.CONTACT_BUTTON}</span>
              </a>
            </DropdownMenuItem>
          )}
          <DropdownMenuItem
            onClick={handleSignOut}
            className="gap-5 py-3 rounded-xl hover:cursor-pointer"
            disabled={logoutMutation.isPending}
          >
            <LogOutIcon size={16} />
            <span>{t.PROFILE_MENU.SIGN_OUT}</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }
  return (
    <header className="flex justify-between items-center px-4 md:px-8 py-4 bg-black text-white">
      <div className="flex items-center">
        <NavLink to="/">
          <img
            src={logo}
            alt="Pulse Logo"
            className="w-7 h-7 md:w-8 md:h-8 mr-2 transition-transform duration-300 hover:scale-125"
          />
        </NavLink>
        <img src={logoText} alt="Pulse Logo" className="w-14 md:w-16" />
      </div>
      <MoreOptionsButton />
    </header>
  );
};

export default HeaderWithLogout;
